import { render, staticRenderFns } from "./chart-block.vue?vue&type=template&id=053e7c8a&scoped=true&"
import script from "./chart-block.vue?vue&type=script&lang=js&"
export * from "./chart-block.vue?vue&type=script&lang=js&"
import style0 from "./chart-block.vue?vue&type=style&index=0&id=053e7c8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "053e7c8a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\projects\\tesas_frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('053e7c8a', component.options)
    } else {
      api.reload('053e7c8a', component.options)
    }
    module.hot.accept("./chart-block.vue?vue&type=template&id=053e7c8a&scoped=true&", function () {
      api.rerender('053e7c8a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/analysis/chart-block.vue"
export default component.exports